import { STORAGE_KEY } from '@/constant/constant';
import { companyUUID, getShopifyUserId } from '@/service/api';
import { getLocal, setLocal } from '@/utils/storage';

const safeJsonParse = (str, fallback) => {
  if (!str) return fallback;
  try {
    return JSON.parse(str);
  } catch {
    return fallback;
  }
};

export const init468 = () => {
  // 只有468 和 test jf站 加载这个埋点
  if (companyUUID === 'lh90b7pi' || companyUUID === 'lef9edad') {
    console.log('加载埋点----------------------');
    if (!window.cartq) {
      // 加载js
      /* eslint-disable */
      !(function (w, d, u, c, e, s) {
        if (w.cartq) return;
        c = w.cartq = function () {
          c.callMethod ? c.callMethod.apply(c, arguments) : c.queue.push(arguments);
        };
        if (!w._cartq) w._cartq = c;
        c.push = c;
        c.loaded = !0;
        c.version = '1.0';
        c.queue = [];
      })(window, document);
      /* eslint-enable */

      let cartElSrc = '';
      for (let el of document.getElementsByTagName('script')) {
        if (/\/carttrack-yueqi.js?/.test(el.src)) {
          cartElSrc = el.src;
          break;
        }
      }
      const companyID = (cartElSrc.match(new RegExp('id=([^&]+)')) || [])[1];
      console.log('加载埋点----------------------    init------id');
      window.cartq('init', 468);
    }
    /* eslint-disable */
    !(function (w, c, u) {
      u = 'https://59b517704ce43f0f.cartseekite.com/cartxtrack';
      c = w.cartq;
      c.params = {};
      c.helper = {
        getCookie: function (c_name) {
          if (document.cookie.length > 0) {
            var c_start = document.cookie.indexOf(c_name + '=');
            if (c_start !== -1) {
              c_start = c_start + c_name.length + 1;
              var c_end = document.cookie.indexOf(';', c_start);
              if (c_end === -1) c_end = document.cookie.length;
              var raw = document.cookie.substring(c_start, c_end);
              try {
                return decodeURIComponent(raw);
              } catch (e) {
                return unescape(raw);
              }
            }
          }
          return '';
        },
        setCookie: function (cname, cvalue, exdays) {
          var d = new Date();
          d.setTime(d.getTime() + exdays * 60 * 1000);
          var expires = 'expires=' + d.toUTCString();
          document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
        },
        getQueryVariable(variable) {
          const urlSearchParams = new URLSearchParams(window.location.search.replace('+', '%2B'));
          return urlSearchParams.get(variable) || '';
        },
        S4: function () {
          return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        },
        guid: function (S4) {
          S4 = c.helper.S4;
          return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
        },
        ajax: {
          get: function (data, fn, errFn) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', data.url, true);
            xhr.onreadystatechange = function () {
              if (xhr.readyState === 4) {
                var responseText;
                try {
                  responseText = JSON.parse(xhr.responseText);
                } catch (e) {
                  responseText = xhr.responseText;
                }
                if (xhr.status === 200 || xhr.status === 304) {
                  fn && fn.call(this, responseText);
                } else {
                  errFn && errFn.call(this, responseText);
                }
              }
            };
            xhr.send();
          },
          post: function (data, fn) {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', data.url, true);
            xhr.setRequestHeader('Content-Type', data.contentType || 'application/json');
            xhr.onreadystatechange = function () {
              if (xhr.readyState === 4 && (xhr.status === 200 || xhr.status === 304)) {
                var responseText;
                try {
                  responseText = JSON.parse(xhr.responseText);
                } catch (e) {
                  responseText = xhr.responseText;
                }
                fn && fn.call(this, responseText);
              }
            };
            xhr.send(data.data);
          }
        }
      };

      c.eventList = {
        init: function (e, id, email) {
          c.id = id;
          c.params = { ...c.params, customer: { ...c.params?.customer, email: email } };
        },
        set: function (e, key, value) {
          c.params = { ...c.params, [key]: value };
        },
        track: function (e, v, d, a) {
          const p = {
            eventType: v,
            companyUUID,
            email: d.email,
            phone: d.phone,
            cid: getLocal(STORAGE_KEY.CARTX_CID) || null
          };
          c.helper.ajax.post({
            url: u,
            contentType: 'application/json',
            data: JSON.stringify(p)
          });
        },
        track1: function (e, v, d, a = {}) {
          // 当它不传email的时候 从localStorage里面取抓取到的email
          if (!d?.email) {
            d = { ...d, email: getLocal(STORAGE_KEY.CARTX_EMAIL) };
          }
          const p = {
            uid: getShopifyUserId(), // 唯一用户标识
            requestId: c.helper.guid(), // 每次request的uuid
            timestamp: Date.now(),
            eventType: v,
            companyId: c.id || '', // companyId 从url的id参数获取
            integrationId: 91, // 468 埋点对接方集成 ID，固定 91，与后端约定
            cid: getLocal(STORAGE_KEY.CARTX_CID) || null,
            customerId: a.customerId, // shopify用户id，在已登录情形下才会有
            data: d
          };
          c.helper.ajax.post({
            url: u,
            contentType: 'application/json',
            data: JSON.stringify(p)
          });
        },
        customerCreate: function (e, v, d, a) {
          const p = {
            eventType: 'Customer/Create',
            companyUUID,
            email: d.email,
            phone: d.phone,
            cid: c.helper.getQueryVariable('cid') || getLocal(STORAGE_KEY.CARTX_CID) || null,
            timestamp: new Date().getTime(),
            uid: getShopifyUserId(),
            source: d.source || 'CartseeAssociation',
            sourceLocation: d.sourceLocation || 'CustomerService'
          };
          c.helper.ajax.post({
            url: u,
            contentType: 'application/json',
            data: JSON.stringify(p)
          });
        }
      };

      if (c.helper.getQueryVariable('cid')) {
        setLocal(STORAGE_KEY.CARTX_CID, c.helper.getQueryVariable('cid'));
      }

      c.callMethod = function () {
        if (arguments.length === 0 || !Object.keys(c.eventList).includes(arguments[0])) return console.warn('no event');
        c.eventList[arguments[0]].apply(c, arguments);
      };
      c.queue.forEach(function (a) {
        c.apply(c, a);
      });
      c.queue = [];

      function isEmail(strEmail) {
        if (`${strEmail}`.search(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/) != -1) {
          return true;
        } else {
          return false;
        }
      }

      function isPhone(strPhone) {
        const str = `${strPhone}`;
        // 美国
        if (str.search(/^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/) != -1) {
          return true;
        } else if (str.search(/^(\(\d{3}\)[ .-]?|\d{3}[ .-]?)?\d{3}[ .-]?\d{4}$/) != -1) {
          return true;
        }
        // 英国
        else if (str.search(/^(\+?44|0)7\d{9}$/) != -1) {
          return true;
        } else if (str.search(/^((\+44\s?\d{4}|\(?\d{5}\)?)\s?\d{6})|((\+44\s?|0)7\d{3}\s?\d{6})$/) != -1) {
          return true;
        }
        // 德国
        else if (str.search(/^(\+?49[ \.\-])?([\(]{1}[0-9]{1,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/) != -1) {
          return true;
        }
        // 法国
        else if (str.search(/^(\+?33|0)[67]\d{8}$/) != -1) {
          return true;
        }
        // 澳大利亚
        else if (str.search(/^((61|\+61)?\s?)04[0-9]{2}\s?([0-9]{3}\s?[0-9]{3}|[0-9]{2}\s?[0-9]{2}\s?[0-9]{2})$/) != -1) {
          return true;
        } else if (str.search(/^(\+?61|0)4\d{8}$/) != -1) {
          return true;
        }
        // 加拿大
        else if (str.search(/^(1[ .-])?(\(\d{3}\)[ .-]|(\d{3}[ .-]?)){2}\d{4}$/) != -1) {
          return true;
        }
        // 日本
        else if (str.search(/^(\+?81|0)?\d{1,4}[ \-]?\d{1,4}[ \-]?\d{4}$/) != -1) {
          return true;
        }
        // 意大利
        else if (str.search(/^(\+?39)?\s?3\d{2} ?\d{6,7}$/) != -1) {
          return true;
        } else if (str.search(/^(([+]|00)39)?((3[1-6][0-9]))(\d{7})$/) != -1) {
          return true;
        } else if (str.search(/^(([0-9]{2,4})([-\s\/]{0,1})([0-9]{4,8}))?$/) != -1) {
          return true;
        }
        // 匹配不到
        return false;
      }

      let time = 0;
      const getGa = () => {
        const strCookie = document?.cookie || '';
        const cookieList = strCookie.split(';');
        const gaList = [];
        const gaCookie = [];
        for (let i = 0; i < cookieList.length; i++) {
          const cookie = cookieList[i];
          const cookieArr = cookie.split('=');
          if (cookieArr.length > 0) {
            if (cookieArr[0].trim().includes('_ga_')) {
              gaList.push(cookieArr[0].trim());
            }
            if (cookieArr[0].trim().includes('_ga')) {
              gaCookie.push(cookie);
            }
          }
        }
        const gaResult = {};
        const promiseList = [];
        const gtag = window.gtag;
        if (gaList.length > 0) {
          if (gtag && typeof gtag === 'function') {
            for (let j = 0; j < gaList.length; j++) {
              const key = gaList[j];
              const arr = key.split('_ga_');
              if (arr.length > 1) {
                const cliPromise = new Promise((resolve, reject) => {
                  gtag('get', 'G-' + arr[1], 'client_id', resolve);
                }).then((res) => {
                  gaResult['G-' + arr[1]] = {
                    ...gaResult['G-' + arr[1]],
                    client_id: res
                  };
                });
                const sesPromise = new Promise((resolve) => {
                  gtag('get', 'G-' + arr[1], 'session_id', resolve);
                }).then((res) => {
                  gaResult['G-' + arr[1]] = {
                    ...gaResult['G-' + arr[1]],
                    session_id: res
                  };
                });
                promiseList.push(cliPromise);
                promiseList.push(sesPromise);
              }
            }
          }
        }

        if (promiseList && promiseList.length > 0) {
          // 有ga
          Promise.all(promiseList)
            .then(() => {})
            .catch(() => {})
            .finally(() => {
              const customer = safeJsonParse(getLocal(STORAGE_KEY.CARTX_CUSTOMER), {});
              const phone = c.params?.customer?.phone || customer?.phone || '';
              const email = c.params?.customer?.email || customer?.email || '';
              // 拿到ga
              c('track1', 'Site/GATrack', {
                pathName: location.href,
                email,
                phone,
                ga: gaResult,
                gac: gaCookie
              });
            });
        } else {
          // 5秒后不再抓取
          if (time < 10) {
            time = time + 1;
            setTimeout(() => {
              getGa();
            }, 500);
          }
        }
      };

      console.log('走到了监听的这里--------');
      if (window.location.hostname === 'test.justfashionnow.com' || window.location.hostname === 'hardaddy.com') {
        if (window.location.pathname.includes('checkout/payment-method')) {
          // 通过classname获取email的dom
          const emailDom = document.querySelector('.input-type input[name="email"]');
          if (emailDom) {
            console.log(emailDom, '第一次能拿到emaildom');
            emailDom.addEventListener('blur', (e) => {
              console.log('email失去焦点');
              setTimeout(() => {
                if (JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email && isEmail(JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email)) {
                  // 当前的email和上一次的email不相同
                  if (getLocal(STORAGE_KEY.OLD_EMAIL_LEGACY) !== JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email) {
                    c('track', 'Customer/Create', {
                      pathName: window.location.href,
                      email: JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email || '',
                      phone: JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone || ''
                    });
                    setLocal(STORAGE_KEY.OLD_EMAIL_LEGACY, JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email);
                    c.helper.setCookie('old-email', JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email, 5);
                  }
                  // 如果相同的邮箱再次进来
                  if (getLocal(STORAGE_KEY.OLD_EMAIL_LEGACY) === JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email) {
                    // 如果上次的上传cookie过期的话就上报
                    if (!c.helper.getCookie('old-email')) {
                      c('track', 'Customer/Create', {
                        pathName: window.location.href,
                        email: JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email || '',
                        phone: JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone || ''
                      });
                      setLocal(STORAGE_KEY.OLD_EMAIL_LEGACY, JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email);
                      c.helper.setCookie('old-email', JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email, 5);
                    } else {
                      console.log('还未过cookie有效期');
                    }
                  }
                } else {
                  console.log('FORM_STORAGE_ITEM 还未注入email');
                }
              }, 100);
            });
          } else {
            let getTimes = 0;
            let timer = setInterval(() => {
              getTimes++;
              const emailDom = document.querySelector('.input-type input[name="email"]');
              if (emailDom) {
                clearInterval(timer);
                console.log(emailDom, `第${getTimes}次拿到emailDom`);
                emailDom.addEventListener('blur', (e) => {
                  console.log('email失去焦点');
                  setTimeout(() => {
                    if (JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email && isEmail(JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email)) {
                      // 当前的email和上一次的email不相同
                      if (getLocal(STORAGE_KEY.OLD_EMAIL_LEGACY) !== JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email) {
                        c('track', 'Customer/Create', {
                          pathName: window.location.href,
                          email: JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email || '',
                          phone: JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone || ''
                        });
                        setLocal(STORAGE_KEY.OLD_EMAIL_LEGACY, JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email);
                        c.helper.setCookie('old-email', JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email, 5);
                      }
                      // 如果相同的邮箱再次进来
                      if (getLocal(STORAGE_KEY.OLD_EMAIL_LEGACY) === JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email) {
                        // 如果上次的上传cookie过期的话就上报
                        if (!c.helper.getCookie('old-email')) {
                          c('track', 'Customer/Create', {
                            pathName: window.location.href,
                            email: JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email || '',
                            phone: JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone || ''
                          });
                          setLocal(STORAGE_KEY.OLD_EMAIL_LEGACY, JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email);
                          c.helper.setCookie('old-email', JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email, 5);
                        } else {
                          console.log('还未过cookie有效期');
                        }
                      }
                    } else {
                      console.log('FORM_STORAGE_ITEM 还未注入email');
                    }
                  }, 100);
                });
              } else if (getTimes >= 35) {
                console.log('30s还是未获取到emaildom');
                clearInterval(timer);
              }
            }, 1000);
          }
          // localStorage中email数据

          const phoneDom = document.querySelector('.input-type input[name="phone"]');
          console.log(phoneDom, 'phoneDomphoneDomphoneDom');
          if (phoneDom) {
            console.log(phoneDom, '第一次能拿到phoneDom');
            phoneDom.addEventListener('blur', (e) => {
              console.log('phone失去焦点');
              setTimeout(() => {
                if (JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone && isPhone(Number(JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone))) {
                  // 当前的phone和上一次的phone不相同
                  if (getLocal(STORAGE_KEY.OLD_PHONE_LEGACY) !== JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone) {
                    c('track', 'Customer/Create', {
                      pathName: window.location.href,
                      email: JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email || '',
                      phone: JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone || ''
                    });
                    setLocal(STORAGE_KEY.OLD_PHONE_LEGACY, JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone);
                    c.helper.setCookie('old-phone', JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone, 5);
                  }
                  // 如果相同的phone再次进来
                  if (getLocal(STORAGE_KEY.OLD_PHONE_LEGACY) === JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone) {
                    // 如果上次的上传cookie过期的话就上报
                    if (!c.helper.getCookie('old-phone')) {
                      c('track', 'Customer/Create', {
                        pathName: window.location.href,
                        email: JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email || '',
                        phone: JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone || ''
                      });
                      setLocal(STORAGE_KEY.OLD_PHONE_LEGACY, JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone);
                      c.helper.setCookie('old-phone', JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone, 5);
                    } else {
                      console.log('还未过cookie有效期');
                    }
                  }
                } else {
                  console.log('FORM_STORAGE_ITEM 还未注入email');
                }
              }, 100);
            });
          } else {
            let getTimes = 0;
            let timer = setInterval(() => {
              getTimes++;
              const phoneDom = document.querySelector('.input-type input[name="phone"]');
              if (phoneDom) {
                clearInterval(timer);
                console.log(phoneDom, `第${getTimes}次拿到phoneDom`);
                phoneDom.addEventListener('blur', (e) => {
                  console.log('phone失去焦点');
                  setTimeout(() => {
                    if (JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone && isPhone(Number(JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone))) {
                      // 当前的email和上一次的email不相同
                      if (getLocal(STORAGE_KEY.OLD_PHONE_LEGACY) !== JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone) {
                        c('track', 'Customer/Create', {
                          pathName: window.location.href,
                          email: JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email || '',
                          phone: JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone || ''
                        });
                        setLocal(STORAGE_KEY.OLD_PHONE_LEGACY, JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone);
                        c.helper.setCookie('old-phone', JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone, 5);
                      }
                      // 如果相同的邮箱再次进来
                      if (getLocal(STORAGE_KEY.OLD_PHONE_LEGACY) === JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone) {
                        // 如果上次的上传cookie过期的话就上报
                        if (!c.helper.getCookie('old-phone')) {
                          c('track', 'Customer/Create', {
                            pathName: window.location.href,
                            email: JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.email || '',
                            phone: JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone || ''
                          });
                          setLocal(STORAGE_KEY.OLD_PHONE_LEGACY, JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone);
                          c.helper.setCookie('old-phone', JSON.parse(getLocal(STORAGE_KEY.FORM_STORAGE_ITEM))?.phone, 5);
                        } else {
                          console.log('还未过cookie有效期');
                        }
                      }
                    } else {
                      console.log('FORM_STORAGE_ITEM 还未注入phone');
                    }
                  }, 100);
                });
              } else if (getTimes >= 35) {
                console.log('30s还是未获取到phone');
                clearInterval(timer);
              }
            }, 1000);
          }
        }
      }
      try {
        if (['lh90b7pi'].includes(companyUUID)) {
          getGa();
        }
      } catch (e) {
        console.log(e);
      }
    })(window);
    /* eslint-enable */
  }
};
